
import React, { Component } from 'react'
import './Saas.scss'

class Saas extends Component {

  render() {
    return (
      <div className="home_bg">
        <div id="saas" className="saasCon">
          <h2>海外SaaS服务 — 东南亚出海一站式互联网金融科技服务</h2>
          <ul>
            <li>
              <img src={require('./images/saas_1.png')}/>
              <p>落地服务方案</p>
            </li>
            <li>
              <img src={require('./images/saas_2.png')}/>
              <p>智能营销</p>
            </li>
            <li>
              <img src={require('./images/saas_3.png')}/>
              <p>智能产品</p>
            </li>
            <li>
              <img src={require('./images/saas_4.png')}/>
              <p>智能风控</p>
            </li>
            <li>
              <img src={require('./images/saas_5.png')}/>
              <p>智能运营</p>
            </li>
          </ul>
          <p className="more">
            <a href="./services/saas">查看详情</a>
          </p>
        </div>
      </div>
    )
  }
}

export { Saas }



// WEBPACK FOOTER //
// ./modules/home/Saas.js